export var reduxKey = '@@deviationPopup';
export var actionKey = '@@deviationPopup';
//# sourceMappingURL=constants.js.map